module.exports = __webpack_public_path__ + "img/支持多种付款方式@2x.5da2798c.png";